var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversLic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 70,
    viewBox: "0 0 105 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 0.000244141H10C4.47715 0.000244141 0 4.47741 0 10.0003V45.2944V60.0002C0 65.5231 4.47716 70.0002 10 70.0002H11.7353H95C100.523 70.0002 105 65.5231 105 60.0002V10.0002C105 4.4774 100.523 0.000244141 95 0.000244141Z",
    fill: "#F1F1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.626 10.7239H9.26562V49.5493H44.626V10.7239Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_515_5969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 36,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.626 10.7239H9.26562V49.5493H44.626V10.7239Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_515_5969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6259 40.5271C23.6647 38.0934 23.6259 35.5812 23.6259 35.5812C23.6259 35.5812 20.5624 35.0317 19.9808 30.9494C19.3991 27.0634 20.3686 18.7026 20.3686 18.7026C24.828 16.9363 29.8303 17.6036 32.9326 21.254L32.4672 40.8803C32.4284 43.157 30.412 44.9233 28.0078 44.8448C25.5648 44.7663 23.6259 42.843 23.6259 40.5271Z",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3887 25.9052C22.3887 26.18 22.5826 26.4155 22.8928 26.4548C23.1642 26.4548 23.3969 26.2585 23.4357 25.9837C23.4357 25.709 23.2418 25.4735 22.9316 25.4342C22.6601 25.4342 22.4274 25.6305 22.3887 25.9052Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5743 25.513C21.6519 25.5915 22.0397 25.2775 22.5826 25.3167C23.6296 25.4737 23.5908 25.6307 23.5908 25.5522C23.6296 25.513 23.552 25.3952 23.3969 25.2775C23.2418 25.1597 22.9316 25.0027 22.5826 25.0027C22.2336 25.0027 21.9621 25.1204 21.7682 25.2382C21.6131 25.356 21.5356 25.4737 21.5743 25.513Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0879 26.1016C28.0879 26.3764 28.2818 26.6119 28.592 26.6511C28.8634 26.6511 29.0961 26.4549 29.1349 26.1801C29.1349 25.9053 28.941 25.6698 28.6308 25.6306C28.3206 25.5913 28.0879 25.8268 28.0879 26.1016Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3517 25.7091C27.4292 25.7876 27.817 25.4736 28.3599 25.5128C28.9028 25.5128 29.3293 25.7876 29.3681 25.7483C29.4069 25.7091 29.3293 25.5913 29.1742 25.4736C29.0191 25.3558 28.7089 25.1988 28.3599 25.1988C28.0109 25.1988 27.7395 25.3165 27.5456 25.4343C27.3905 25.5521 27.3129 25.6698 27.3517 25.7091Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8568 29.6455C25.8461 29.6064 25.5365 29.6273 25.0502 29.6423C24.9173 29.6689 24.807 29.6499 24.7416 29.5394C24.6762 29.4288 24.6996 29.2593 24.7231 29.0898C24.7593 28.7117 24.7623 28.3402 24.7878 27.9231C24.8672 26.3002 24.9114 24.9315 24.845 24.9448C24.7678 24.9191 24.6797 26.2553 24.5671 27.8849C24.5416 28.3021 24.5386 28.6735 24.5024 29.0516C24.5121 29.2145 24.4662 29.4297 24.5863 29.6117C24.6517 29.7222 24.7728 29.7803 24.8392 29.767C24.9163 29.7928 24.9827 29.7795 25.0492 29.7661C25.558 29.7054 25.8568 29.6455 25.8568 29.6455Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 35.542C23.625 35.542 27.1615 36.3913 29.8371 34.8212C29.8371 34.8212 27.6967 36.9551 23.6638 36.5233L23.625 35.542Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9624 31.3426C25.9002 31.3014 25.5202 31.7895 24.8605 31.8951C24.2007 32.0008 23.7191 31.5833 23.6725 31.6511C23.6493 31.685 23.727 31.8351 23.9445 31.9791C24.162 32.1231 24.5192 32.2609 24.9073 32.222C25.3187 32.1492 25.6523 31.9263 25.7919 31.7228C25.9625 31.5399 25.9934 31.3631 25.9624 31.3426Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1857 18.2968C29.5376 20.6675 25.2005 23.126 22.0778 23.6528C22.4247 23.1699 24.3331 21.9846 24.7234 21.5016C23.2922 22.5553 21.2971 24.0041 19.4322 24.0919C19.2153 24.0919 18.9551 24.0919 18.7816 24.0041C18.5214 23.8724 18.478 23.565 18.4346 23.3016C18.3045 22.2041 18.1985 20.432 18.372 19.3344C18.5455 18.2369 19.2587 16.9797 20.1695 16.2334C21.3838 15.3115 23.0753 14.6458 24.7234 14.6019C26.0679 14.558 27.4991 14.6458 28.7135 15.1287C29.9713 15.6117 31.0122 17.0236 31.1857 18.1651",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2679 27.1782C35.8713 26.1726 36.2347 24.6275 36.2735 23.9602C36.3898 21.8798 35.3363 15.3268 28.2012 15.9156L29.5 18.1137C29.5 18.1137 26.6195 22.5523 31.4197 25.6895C31.4197 25.6895 31.2454 27.1782 32.8544 29.3906C32.8544 29.3906 33.4578 29.7929 35.2679 27.1782Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4185 25.6899C31.8451 25.6114 32.3104 25.6114 32.6982 25.8077C33.0859 25.9647 33.4737 26.2787 33.6288 26.6712C33.7839 27.0638 33.7839 27.5348 33.6288 27.9666C33.4737 28.3983 33.2023 28.7516 32.8921 29.0656C32.6594 29.3011 32.4267 29.4974 32.1165 29.5759C31.8063 29.6544 31.4573 29.6152 31.2246 29.4189",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7141 28.6894C31.6763 28.6981 31.8888 28.9313 32.2871 28.7596C32.4673 28.678 32.6213 28.4817 32.6821 28.2262C32.7517 28.0089 32.7747 27.762 32.7512 27.4855C32.7277 27.209 32.5907 26.9585 32.4248 26.7549C32.2298 26.5982 32.0057 26.4884 31.8167 26.5317C31.4387 26.6182 31.3489 26.9207 31.3867 26.912C31.4332 26.9416 31.5494 26.754 31.8315 26.7699C32.1049 26.7476 32.4105 27.04 32.44 27.5165C32.4986 27.946 32.406 28.4102 32.1967 28.5386C31.9206 28.7227 31.7431 28.6425 31.7141 28.6894Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57422 61.8886L10.8674 49.4236L17.5371 53.6629L12.8815 61.8886C12.8815 61.8886 11.3521 61.8886 5.57422 61.8886Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5301 40.6055C19.6323 38.9569 23.6264 38.4858 23.6264 38.4858C24.7897 40.841 28.4736 41.155 30.684 39.5456L32.5453 38.2503C32.5453 38.2503 32.8167 38.2503 33.3209 38.2896C37.2334 39.3339 39.8051 40.2983 41.0909 40.9412C43.3411 42.8699 45.7077 50.4579 45.5913 52.1457C45.3587 56.4243 38.0517 56.1495 38.0517 56.1495C38.0517 56.1495 37.9651 58.134 37.6936 61.549C35.3145 61.549 36.0353 61.3388 33.7086 62.3986C32.0024 63.1837 33.5514 61.549 27.8372 61.549C19.5103 61.549 22.909 61.549 17.3011 61.549C17.9603 57.4667 15.5606 56.385 15.4831 56.1495C15.4831 56.1102 15.4831 56.071 15.4831 56.071L11.14 52.1457L8.6582 50.0653C8.69698 50.0653 14.0871 41.94 16.5301 40.6055Z",
    fill: "#2DA771"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.26367 57.3384H95.7343",
    stroke: "#6C6D8A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.5 38.578H95.7353",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.5 31.4374H68.25",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.6758 31.4374H95.4258",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.5 48.6913H72.45",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M52.5 16.5735H95.7353",
    stroke: "#6C6D8A",
    strokeWidth: 14,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLic);
export default __webpack_public_path__ + "static/media/driversLic.9866cadcf23a4ab15fe7c114a95ca7a8.svg";
export { ForwardRef as ReactComponent };